import { render, staticRenderFns } from "./QuestionYesNo.vue?vue&type=template&id=69533cdc&scoped=true&"
import script from "./QuestionYesNo.vue?vue&type=script&lang=js&"
export * from "./QuestionYesNo.vue?vue&type=script&lang=js&"
import style0 from "./QuestionYesNo.vue?vue&type=style&index=0&id=69533cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69533cdc",
  null
  
)

export default component.exports